import React from 'react';

import Drawer from '../../common2/drawer/Drawer';
import CreateClaimContainer from './CreateClaimContainer';
import { ClaimableShipment } from '../../../api/types';
import { SubmitClaimEntryPoint } from '../../parcel-finder/claims/types';

type Props = {
  isOpen?: boolean;
  shipment?: ClaimableShipment;
  draftId?: number | null;
  entryPoint: SubmitClaimEntryPoint;
  onClose: () => void;
  onClaimSubmitted?: (claimId: string) => void;
};

function SubmitClaimPanel(props: Props) {
  const { isOpen, shipment, draftId, entryPoint, onClose, onClaimSubmitted } = props;

  return (
    <Drawer isOpen={isOpen}>
      <CreateClaimContainer
        shipment={shipment}
        draftId={draftId}
        entryPoint={entryPoint}
        onClose={onClose}
        onClaimSubmitted={onClaimSubmitted}
      />
    </Drawer>
  );
}

export default React.memo(SubmitClaimPanel);
